var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPracticeareaDot(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 302,
    height: 347,
    viewBox: "0 0 302 347",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M302 2.2382V3.73034H300.047V5.96854H298.746V3.73034H296.793V2.2382H298.746V0H300.047V2.2382H302Z",
    fill: "#B68C5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302 20.1437V21.6359H300.047V23.8741H298.746V21.6359H296.793V20.1437H298.746V17.9055H300.047V20.1437H302Z",
    fill: "#B68C5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302 38.0495V39.5416H300.047V41.7798H298.746V39.5416H296.793V38.0495H298.746V35.8113H300.047V38.0495H302Z",
    fill: "#B68C5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302 55.955V57.4471H300.047V59.6853H298.746V57.4471H296.793V55.955H298.746V53.7168H300.047V55.955H302Z",
    fill: "#B68C5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302 73.8605V75.3527H300.047V77.5909H298.746V75.3527H296.793V73.8605H298.746V71.6223H300.047V73.8605H302Z",
    fill: "#B68C5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302 91.766V93.2582H300.047V95.4964H298.746V93.2582H296.793V91.766H298.746V89.5278H300.047V91.766H302Z",
    fill: "#B68C5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302 109.672V111.164H300.047V113.402H298.746V111.164H296.793V109.672H298.746V107.434H300.047V109.672H302Z",
    fill: "#B68C5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302 127.577V129.069H300.047V131.308H298.746V129.069H296.793V127.577H298.746V125.339H300.047V127.577H302Z",
    fill: "#B68C5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302 145.483V146.975H300.047V149.213H298.746V146.975H296.793V145.483H298.746V143.245H300.047V145.483H302Z",
    fill: "#B68C5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302 163.389V164.881H300.047V167.119H298.746V164.881H296.793V163.389H298.746V161.15H300.047V163.389H302Z",
    fill: "#B68C5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302 181.294V182.786H300.047V185.025H298.746V182.786H296.793V181.294H298.746V179.056H300.047V181.294H302Z",
    fill: "#B68C5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302 199.2V200.692H300.047V202.93H298.746V200.692H296.793V199.2H298.746V196.961H300.047V199.2H302Z",
    fill: "#B68C5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302 217.105V218.598H300.047V220.836H298.746V218.598H296.793V217.105H298.746V214.867H300.047V217.105H302Z",
    fill: "#B68C5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302 235.011V236.503H300.047V238.741H298.746V236.503H296.793V235.011H298.746V232.773H300.047V235.011H302Z",
    fill: "#B68C5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302 252.916V254.409H300.047V256.647H298.746V254.409H296.793V252.916H298.746V250.678H300.047V252.916H302Z",
    fill: "#B68C5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302 270.822V272.314H300.047V274.553H298.746V272.314H296.793V270.822H298.746V268.584H300.047V270.822H302Z",
    fill: "#B68C5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302 288.728V290.22H300.047V292.458H298.746V290.22H296.793V288.728H298.746V286.49H300.047V288.728H302Z",
    fill: "#B68C5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302 306.633V308.125H300.047V310.364H298.746V308.125H296.793V306.633H298.746V304.395H300.047V306.633H302Z",
    fill: "#B68C5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302 324.539V326.031H300.047V328.269H298.746V326.031H296.793V324.539H298.746V322.301H300.047V324.539H302Z",
    fill: "#B68C5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302 342.444V343.937H300.047V346.175H298.746V343.937H296.793V342.444H298.746V340.206H300.047V342.444H302Z",
    fill: "#B68C5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.38 2.2382V3.73034H284.427V5.96854H283.125V3.73034H281.173V2.2382H283.125V0H284.427V2.2382H286.38Z",
    fill: "#B68C5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.38 20.1437V21.6359H284.427V23.8741H283.125V21.6359H281.173V20.1437H283.125V17.9055H284.427V20.1437H286.38Z",
    fill: "#B68C5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.38 38.0495V39.5416H284.427V41.7798H283.125V39.5416H281.173V38.0495H283.125V35.8113H284.427V38.0495H286.38Z",
    fill: "#B68C5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.38 55.955V57.4471H284.427V59.6853H283.125V57.4471H281.173V55.955H283.125V53.7168H284.427V55.955H286.38Z",
    fill: "#B68C5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.38 73.8605V75.3527H284.427V77.5909H283.125V75.3527H281.173V73.8605H283.125V71.6223H284.427V73.8605H286.38Z",
    fill: "#B68C5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.38 91.766V93.2582H284.427V95.4964H283.125V93.2582H281.173V91.766H283.125V89.5278H284.427V91.766H286.38Z",
    fill: "#B68C5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.38 109.672V111.164H284.427V113.402H283.125V111.164H281.173V109.672H283.125V107.434H284.427V109.672H286.38Z",
    fill: "#B68C5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.38 127.577V129.069H284.427V131.308H283.125V129.069H281.173V127.577H283.125V125.339H284.427V127.577H286.38Z",
    fill: "#B68C5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.38 145.483V146.975H284.427V149.213H283.125V146.975H281.173V145.483H283.125V143.245H284.427V145.483H286.38Z",
    fill: "#B68C5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.38 163.389V164.881H284.427V167.119H283.125V164.881H281.173V163.389H283.125V161.15H284.427V163.389H286.38Z",
    fill: "#B68C5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.38 181.294V182.786H284.427V185.025H283.125V182.786H281.173V181.294H283.125V179.056H284.427V181.294H286.38Z",
    fill: "#B68C5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.38 199.2V200.692H284.427V202.93H283.125V200.692H281.173V199.2H283.125V196.961H284.427V199.2H286.38Z",
    fill: "#B68C5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.38 217.105V218.598H284.427V220.836H283.125V218.598H281.173V217.105H283.125V214.867H284.427V217.105H286.38Z",
    fill: "#B68C5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.38 235.011V236.503H284.427V238.741H283.125V236.503H281.173V235.011H283.125V232.773H284.427V235.011H286.38Z",
    fill: "#B68C5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.38 252.916V254.409H284.427V256.647H283.125V254.409H281.173V252.916H283.125V250.678H284.427V252.916H286.38Z",
    fill: "#B68C5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.38 270.822V272.314H284.427V274.553H283.125V272.314H281.173V270.822H283.125V268.584H284.427V270.822H286.38Z",
    fill: "#B68C5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.38 288.728V290.22H284.427V292.458H283.125V290.22H281.173V288.728H283.125V286.49H284.427V288.728H286.38Z",
    fill: "#B68C5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.38 306.633V308.125H284.427V310.364H283.125V308.125H281.173V306.633H283.125V304.395H284.427V306.633H286.38Z",
    fill: "#B68C5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.38 324.539V326.031H284.427V328.269H283.125V326.031H281.173V324.539H283.125V322.301H284.427V324.539H286.38Z",
    fill: "#B68C5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.38 342.444V343.937H284.427V346.175H283.125V343.937H281.173V342.444H283.125V340.206H284.427V342.444H286.38Z",
    fill: "#B68C5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.759 2.2382V3.73034H268.806V5.96854H267.504V3.73034H265.552V2.2382H267.504V0H268.806V2.2382H270.759Z",
    fill: "#B68C5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.759 20.1437V21.6359H268.806V23.8741H267.504V21.6359H265.552V20.1437H267.504V17.9055H268.806V20.1437H270.759Z",
    fill: "#B68C5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.759 38.0495V39.5416H268.806V41.7798H267.504V39.5416H265.552V38.0495H267.504V35.8113H268.806V38.0495H270.759Z",
    fill: "#B68C5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.759 55.955V57.4471H268.806V59.6853H267.504V57.4471H265.552V55.955H267.504V53.7168H268.806V55.955H270.759Z",
    fill: "#B68C5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.759 73.8605V75.3527H268.806V77.5909H267.504V75.3527H265.552V73.8605H267.504V71.6223H268.806V73.8605H270.759Z",
    fill: "#B68C5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.759 91.766V93.2582H268.806V95.4964H267.504V93.2582H265.552V91.766H267.504V89.5278H268.806V91.766H270.759Z",
    fill: "#B68C5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.759 109.672V111.164H268.806V113.402H267.504V111.164H265.552V109.672H267.504V107.434H268.806V109.672H270.759Z",
    fill: "#B68C5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.759 127.577V129.069H268.806V131.308H267.504V129.069H265.552V127.577H267.504V125.339H268.806V127.577H270.759Z",
    fill: "#B68C5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.759 145.483V146.975H268.806V149.213H267.504V146.975H265.552V145.483H267.504V143.245H268.806V145.483H270.759Z",
    fill: "#B68C5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.759 163.389V164.881H268.806V167.119H267.504V164.881H265.552V163.389H267.504V161.15H268.806V163.389H270.759Z",
    fill: "#B68C5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.759 181.294V182.786H268.806V185.025H267.504V182.786H265.552V181.294H267.504V179.056H268.806V181.294H270.759Z",
    fill: "#B68C5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.759 199.2V200.692H268.806V202.93H267.504V200.692H265.552V199.2H267.504V196.961H268.806V199.2H270.759Z",
    fill: "#B68C5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.759 217.105V218.598H268.806V220.836H267.504V218.598H265.552V217.105H267.504V214.867H268.806V217.105H270.759Z",
    fill: "#B68C5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.759 235.011V236.503H268.806V238.741H267.504V236.503H265.552V235.011H267.504V232.773H268.806V235.011H270.759Z",
    fill: "#B68C5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.759 252.916V254.409H268.806V256.647H267.504V254.409H265.552V252.916H267.504V250.678H268.806V252.916H270.759Z",
    fill: "#B68C5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.759 270.822V272.314H268.806V274.553H267.504V272.314H265.552V270.822H267.504V268.584H268.806V270.822H270.759Z",
    fill: "#B68C5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.759 288.728V290.22H268.806V292.458H267.504V290.22H265.552V288.728H267.504V286.49H268.806V288.728H270.759Z",
    fill: "#B68C5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.759 306.633V308.125H268.806V310.364H267.504V308.125H265.552V306.633H267.504V304.395H268.806V306.633H270.759Z",
    fill: "#B68C5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.759 324.539V326.031H268.806V328.269H267.504V326.031H265.552V324.539H267.504V322.301H268.806V324.539H270.759Z",
    fill: "#B68C5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.759 342.444V343.937H268.806V346.175H267.504V343.937H265.552V342.444H267.504V340.206H268.806V342.444H270.759Z",
    fill: "#B68C5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.139 2.2382V3.73034H253.186V5.96854H251.884V3.73034H249.932V2.2382H251.884V0H253.186V2.2382H255.139Z",
    fill: "#B68C5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.139 20.1437V21.6359H253.186V23.8741H251.884V21.6359H249.932V20.1437H251.884V17.9055H253.186V20.1437H255.139Z",
    fill: "#B68C5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.139 38.0495V39.5416H253.186V41.7798H251.884V39.5416H249.932V38.0495H251.884V35.8113H253.186V38.0495H255.139Z",
    fill: "#B68C5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.139 55.955V57.4471H253.186V59.6853H251.884V57.4471H249.932V55.955H251.884V53.7168H253.186V55.955H255.139Z",
    fill: "#B68C5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.139 73.8605V75.3527H253.186V77.5909H251.884V75.3527H249.932V73.8605H251.884V71.6223H253.186V73.8605H255.139Z",
    fill: "#B68C5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.139 91.766V93.2582H253.186V95.4964H251.884V93.2582H249.932V91.766H251.884V89.5278H253.186V91.766H255.139Z",
    fill: "#B68C5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.139 109.672V111.164H253.186V113.402H251.884V111.164H249.932V109.672H251.884V107.434H253.186V109.672H255.139Z",
    fill: "#B68C5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.139 127.577V129.069H253.186V131.308H251.884V129.069H249.932V127.577H251.884V125.339H253.186V127.577H255.139Z",
    fill: "#B68C5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.139 145.483V146.975H253.186V149.213H251.884V146.975H249.932V145.483H251.884V143.245H253.186V145.483H255.139Z",
    fill: "#B68C5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.139 163.389V164.881H253.186V167.119H251.884V164.881H249.932V163.389H251.884V161.15H253.186V163.389H255.139Z",
    fill: "#B68C5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.139 181.294V182.786H253.186V185.025H251.884V182.786H249.932V181.294H251.884V179.056H253.186V181.294H255.139Z",
    fill: "#B68C5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.139 199.2V200.692H253.186V202.93H251.884V200.692H249.932V199.2H251.884V196.961H253.186V199.2H255.139Z",
    fill: "#B68C5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.139 217.105V218.598H253.186V220.836H251.884V218.598H249.932V217.105H251.884V214.867H253.186V217.105H255.139Z",
    fill: "#B68C5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.139 235.011V236.503H253.186V238.741H251.884V236.503H249.932V235.011H251.884V232.773H253.186V235.011H255.139Z",
    fill: "#B68C5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.139 252.916V254.409H253.186V256.647H251.884V254.409H249.932V252.916H251.884V250.678H253.186V252.916H255.139Z",
    fill: "#B68C5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.139 270.822V272.314H253.186V274.553H251.884V272.314H249.932V270.822H251.884V268.584H253.186V270.822H255.139Z",
    fill: "#B68C5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.139 288.728V290.22H253.186V292.458H251.884V290.22H249.932V288.728H251.884V286.49H253.186V288.728H255.139Z",
    fill: "#B68C5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.139 306.633V308.125H253.186V310.364H251.884V308.125H249.932V306.633H251.884V304.395H253.186V306.633H255.139Z",
    fill: "#B68C5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.139 324.539V326.031H253.186V328.269H251.884V326.031H249.932V324.539H251.884V322.301H253.186V324.539H255.139Z",
    fill: "#B68C5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.139 342.444V343.937H253.186V346.175H251.884V343.937H249.932V342.444H251.884V340.206H253.186V342.444H255.139Z",
    fill: "#B68C5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.518 2.2382V3.73034H237.565V5.96854H236.263V3.73034H234.311V2.2382H236.263V0H237.565V2.2382H239.518Z",
    fill: "#B68C5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.518 20.1437V21.6359H237.565V23.8741H236.263V21.6359H234.311V20.1437H236.263V17.9055H237.565V20.1437H239.518Z",
    fill: "#B68C5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.518 38.0495V39.5416H237.565V41.7798H236.263V39.5416H234.311V38.0495H236.263V35.8113H237.565V38.0495H239.518Z",
    fill: "#B68C5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.518 55.955V57.4471H237.565V59.6853H236.263V57.4471H234.311V55.955H236.263V53.7168H237.565V55.955H239.518Z",
    fill: "#B68C5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.518 73.8605V75.3527H237.565V77.5909H236.263V75.3527H234.311V73.8605H236.263V71.6223H237.565V73.8605H239.518Z",
    fill: "#B68C5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.518 91.766V93.2582H237.565V95.4964H236.263V93.2582H234.311V91.766H236.263V89.5278H237.565V91.766H239.518Z",
    fill: "#B68C5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.518 109.672V111.164H237.565V113.402H236.263V111.164H234.311V109.672H236.263V107.434H237.565V109.672H239.518Z",
    fill: "#B68C5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.518 127.577V129.069H237.565V131.308H236.263V129.069H234.311V127.577H236.263V125.339H237.565V127.577H239.518Z",
    fill: "#B68C5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.518 145.483V146.975H237.565V149.213H236.263V146.975H234.311V145.483H236.263V143.245H237.565V145.483H239.518Z",
    fill: "#B68C5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.518 163.389V164.881H237.565V167.119H236.263V164.881H234.311V163.389H236.263V161.15H237.565V163.389H239.518Z",
    fill: "#B68C5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.518 181.294V182.786H237.565V185.025H236.263V182.786H234.311V181.294H236.263V179.056H237.565V181.294H239.518Z",
    fill: "#B68C5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.518 199.2V200.692H237.565V202.93H236.263V200.692H234.311V199.2H236.263V196.961H237.565V199.2H239.518Z",
    fill: "#B68C5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.518 217.105V218.598H237.565V220.836H236.263V218.598H234.311V217.105H236.263V214.867H237.565V217.105H239.518Z",
    fill: "#B68C5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.518 235.011V236.503H237.565V238.741H236.263V236.503H234.311V235.011H236.263V232.773H237.565V235.011H239.518Z",
    fill: "#B68C5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.518 252.916V254.409H237.565V256.647H236.263V254.409H234.311V252.916H236.263V250.678H237.565V252.916H239.518Z",
    fill: "#B68C5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.518 270.822V272.314H237.565V274.553H236.263V272.314H234.311V270.822H236.263V268.584H237.565V270.822H239.518Z",
    fill: "#B68C5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.518 288.728V290.22H237.565V292.458H236.263V290.22H234.311V288.728H236.263V286.49H237.565V288.728H239.518Z",
    fill: "#B68C5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.518 306.633V308.125H237.565V310.364H236.263V308.125H234.311V306.633H236.263V304.395H237.565V306.633H239.518Z",
    fill: "#B68C5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.518 324.539V326.031H237.565V328.269H236.263V326.031H234.311V324.539H236.263V322.301H237.565V324.539H239.518Z",
    fill: "#B68C5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.518 342.444V343.937H237.565V346.175H236.263V343.937H234.311V342.444H236.263V340.206H237.565V342.444H239.518Z",
    fill: "#B68C5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.896 2.2382V3.73034H221.944V5.96854H220.642V3.73034H218.689V2.2382H220.642V0H221.944V2.2382H223.896Z",
    fill: "#B68C5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.896 20.1437V21.6359H221.944V23.8741H220.642V21.6359H218.689V20.1437H220.642V17.9055H221.944V20.1437H223.896Z",
    fill: "#B68C5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.896 38.0495V39.5416H221.944V41.7798H220.642V39.5416H218.689V38.0495H220.642V35.8113H221.944V38.0495H223.896Z",
    fill: "#B68C5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.896 55.955V57.4471H221.944V59.6853H220.642V57.4471H218.689V55.955H220.642V53.7168H221.944V55.955H223.896Z",
    fill: "#B68C5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.896 73.8605V75.3527H221.944V77.5909H220.642V75.3527H218.689V73.8605H220.642V71.6223H221.944V73.8605H223.896Z",
    fill: "#B68C5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.896 91.766V93.2582H221.944V95.4964H220.642V93.2582H218.689V91.766H220.642V89.5278H221.944V91.766H223.896Z",
    fill: "#B68C5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.896 109.672V111.164H221.944V113.402H220.642V111.164H218.689V109.672H220.642V107.434H221.944V109.672H223.896Z",
    fill: "#B68C5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.896 127.577V129.069H221.944V131.308H220.642V129.069H218.689V127.577H220.642V125.339H221.944V127.577H223.896Z",
    fill: "#B68C5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.896 145.483V146.975H221.944V149.213H220.642V146.975H218.689V145.483H220.642V143.245H221.944V145.483H223.896Z",
    fill: "#B68C5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.896 163.389V164.881H221.944V167.119H220.642V164.881H218.689V163.389H220.642V161.15H221.944V163.389H223.896Z",
    fill: "#B68C5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.896 181.294V182.786H221.944V185.025H220.642V182.786H218.689V181.294H220.642V179.056H221.944V181.294H223.896Z",
    fill: "#B68C5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.896 199.2V200.692H221.944V202.93H220.642V200.692H218.689V199.2H220.642V196.961H221.944V199.2H223.896Z",
    fill: "#B68C5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.896 217.105V218.598H221.944V220.836H220.642V218.598H218.689V217.105H220.642V214.867H221.944V217.105H223.896Z",
    fill: "#B68C5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.896 235.011V236.503H221.944V238.741H220.642V236.503H218.689V235.011H220.642V232.773H221.944V235.011H223.896Z",
    fill: "#B68C5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.896 252.916V254.409H221.944V256.647H220.642V254.409H218.689V252.916H220.642V250.678H221.944V252.916H223.896Z",
    fill: "#B68C5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.896 270.822V272.314H221.944V274.553H220.642V272.314H218.689V270.822H220.642V268.584H221.944V270.822H223.896Z",
    fill: "#B68C5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.896 288.728V290.22H221.944V292.458H220.642V290.22H218.689V288.728H220.642V286.49H221.944V288.728H223.896Z",
    fill: "#B68C5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.896 306.633V308.125H221.944V310.364H220.642V308.125H218.689V306.633H220.642V304.395H221.944V306.633H223.896Z",
    fill: "#B68C5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.896 324.539V326.031H221.944V328.269H220.642V326.031H218.689V324.539H220.642V322.301H221.944V324.539H223.896Z",
    fill: "#B68C5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.896 342.444V343.937H221.944V346.175H220.642V343.937H218.689V342.444H220.642V340.206H221.944V342.444H223.896Z",
    fill: "#B68C5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.276 2.2382V3.73034H206.324V5.96854H205.022V3.73034H203.069V2.2382H205.022V0H206.324V2.2382H208.276Z",
    fill: "#B68C5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.276 20.1437V21.6359H206.324V23.8741H205.022V21.6359H203.069V20.1437H205.022V17.9055H206.324V20.1437H208.276Z",
    fill: "#B68C5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.276 38.0495V39.5416H206.324V41.7798H205.022V39.5416H203.069V38.0495H205.022V35.8113H206.324V38.0495H208.276Z",
    fill: "#B68C5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.276 55.955V57.4471H206.324V59.6853H205.022V57.4471H203.069V55.955H205.022V53.7168H206.324V55.955H208.276Z",
    fill: "#B68C5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.276 73.8605V75.3527H206.324V77.5909H205.022V75.3527H203.069V73.8605H205.022V71.6223H206.324V73.8605H208.276Z",
    fill: "#B68C5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.276 91.766V93.2582H206.324V95.4964H205.022V93.2582H203.069V91.766H205.022V89.5278H206.324V91.766H208.276Z",
    fill: "#B68C5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.276 109.672V111.164H206.324V113.402H205.022V111.164H203.069V109.672H205.022V107.434H206.324V109.672H208.276Z",
    fill: "#B68C5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.276 127.577V129.069H206.324V131.308H205.022V129.069H203.069V127.577H205.022V125.339H206.324V127.577H208.276Z",
    fill: "#B68C5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.276 145.483V146.975H206.324V149.213H205.022V146.975H203.069V145.483H205.022V143.245H206.324V145.483H208.276Z",
    fill: "#B68C5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.276 163.389V164.881H206.324V167.119H205.022V164.881H203.069V163.389H205.022V161.15H206.324V163.389H208.276Z",
    fill: "#B68C5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.276 181.294V182.786H206.324V185.025H205.022V182.786H203.069V181.294H205.022V179.056H206.324V181.294H208.276Z",
    fill: "#B68C5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.276 199.2V200.692H206.324V202.93H205.022V200.692H203.069V199.2H205.022V196.961H206.324V199.2H208.276Z",
    fill: "#B68C5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.276 217.105V218.598H206.324V220.836H205.022V218.598H203.069V217.105H205.022V214.867H206.324V217.105H208.276Z",
    fill: "#B68C5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.276 235.011V236.503H206.324V238.741H205.022V236.503H203.069V235.011H205.022V232.773H206.324V235.011H208.276Z",
    fill: "#B68C5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.276 252.916V254.409H206.324V256.647H205.022V254.409H203.069V252.916H205.022V250.678H206.324V252.916H208.276Z",
    fill: "#B68C5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.276 270.822V272.314H206.324V274.553H205.022V272.314H203.069V270.822H205.022V268.584H206.324V270.822H208.276Z",
    fill: "#B68C5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.276 288.728V290.22H206.324V292.458H205.022V290.22H203.069V288.728H205.022V286.49H206.324V288.728H208.276Z",
    fill: "#B68C5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.276 306.633V308.125H206.324V310.364H205.022V308.125H203.069V306.633H205.022V304.395H206.324V306.633H208.276Z",
    fill: "#B68C5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.276 324.539V326.031H206.324V328.269H205.022V326.031H203.069V324.539H205.022V322.301H206.324V324.539H208.276Z",
    fill: "#B68C5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.276 342.444V343.937H206.324V346.175H205.022V343.937H203.069V342.444H205.022V340.206H206.324V342.444H208.276Z",
    fill: "#B68C5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.655 2.2382V3.73034H190.703V5.96854H189.401V3.73034H187.448V2.2382H189.401V0H190.703V2.2382H192.655Z",
    fill: "#B68C5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.655 20.1437V21.6359H190.703V23.8741H189.401V21.6359H187.448V20.1437H189.401V17.9055H190.703V20.1437H192.655Z",
    fill: "#B68C5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.655 38.0495V39.5416H190.703V41.7798H189.401V39.5416H187.448V38.0495H189.401V35.8113H190.703V38.0495H192.655Z",
    fill: "#B68C5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.655 55.955V57.4471H190.703V59.6853H189.401V57.4471H187.448V55.955H189.401V53.7168H190.703V55.955H192.655Z",
    fill: "#B68C5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.655 73.8605V75.3527H190.703V77.5909H189.401V75.3527H187.448V73.8605H189.401V71.6223H190.703V73.8605H192.655Z",
    fill: "#B68C5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.655 91.766V93.2582H190.703V95.4964H189.401V93.2582H187.448V91.766H189.401V89.5278H190.703V91.766H192.655Z",
    fill: "#B68C5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.655 109.672V111.164H190.703V113.402H189.401V111.164H187.448V109.672H189.401V107.434H190.703V109.672H192.655Z",
    fill: "#B68C5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.655 127.577V129.069H190.703V131.308H189.401V129.069H187.448V127.577H189.401V125.339H190.703V127.577H192.655Z",
    fill: "#B68C5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.655 145.483V146.975H190.703V149.213H189.401V146.975H187.448V145.483H189.401V143.245H190.703V145.483H192.655Z",
    fill: "#B68C5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.655 163.389V164.881H190.703V167.119H189.401V164.881H187.448V163.389H189.401V161.15H190.703V163.389H192.655Z",
    fill: "#B68C5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.655 181.294V182.786H190.703V185.025H189.401V182.786H187.448V181.294H189.401V179.056H190.703V181.294H192.655Z",
    fill: "#B68C5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.655 199.2V200.692H190.703V202.93H189.401V200.692H187.448V199.2H189.401V196.961H190.703V199.2H192.655Z",
    fill: "#B68C5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.655 217.105V218.598H190.703V220.836H189.401V218.598H187.448V217.105H189.401V214.867H190.703V217.105H192.655Z",
    fill: "#B68C5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.655 235.011V236.503H190.703V238.741H189.401V236.503H187.448V235.011H189.401V232.773H190.703V235.011H192.655Z",
    fill: "#B68C5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.655 252.916V254.409H190.703V256.647H189.401V254.409H187.448V252.916H189.401V250.678H190.703V252.916H192.655Z",
    fill: "#B68C5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.655 270.822V272.314H190.703V274.553H189.401V272.314H187.448V270.822H189.401V268.584H190.703V270.822H192.655Z",
    fill: "#B68C5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.655 288.728V290.22H190.703V292.458H189.401V290.22H187.448V288.728H189.401V286.49H190.703V288.728H192.655Z",
    fill: "#B68C5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.655 306.633V308.125H190.703V310.364H189.401V308.125H187.448V306.633H189.401V304.395H190.703V306.633H192.655Z",
    fill: "#B68C5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.655 324.539V326.031H190.703V328.269H189.401V326.031H187.448V324.539H189.401V322.301H190.703V324.539H192.655Z",
    fill: "#B68C5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.655 342.444V343.937H190.703V346.175H189.401V343.937H187.448V342.444H189.401V340.206H190.703V342.444H192.655Z",
    fill: "#B68C5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.035 2.2382V3.73034H175.082V5.96854H173.781V3.73034H171.828V2.2382H173.781V0H175.082V2.2382H177.035Z",
    fill: "#B68C5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.035 20.1437V21.6359H175.082V23.8741H173.781V21.6359H171.828V20.1437H173.781V17.9055H175.082V20.1437H177.035Z",
    fill: "#B68C5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.035 38.0495V39.5416H175.082V41.7798H173.781V39.5416H171.828V38.0495H173.781V35.8113H175.082V38.0495H177.035Z",
    fill: "#B68C5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.035 55.955V57.4471H175.082V59.6853H173.781V57.4471H171.828V55.955H173.781V53.7168H175.082V55.955H177.035Z",
    fill: "#B68C5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.035 73.8605V75.3527H175.082V77.5909H173.781V75.3527H171.828V73.8605H173.781V71.6223H175.082V73.8605H177.035Z",
    fill: "#B68C5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.035 91.766V93.2582H175.082V95.4964H173.781V93.2582H171.828V91.766H173.781V89.5278H175.082V91.766H177.035Z",
    fill: "#B68C5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.035 109.672V111.164H175.082V113.402H173.781V111.164H171.828V109.672H173.781V107.434H175.082V109.672H177.035Z",
    fill: "#B68C5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.035 127.577V129.069H175.082V131.308H173.781V129.069H171.828V127.577H173.781V125.339H175.082V127.577H177.035Z",
    fill: "#B68C5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.035 145.483V146.975H175.082V149.213H173.781V146.975H171.828V145.483H173.781V143.245H175.082V145.483H177.035Z",
    fill: "#B68C5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.035 163.389V164.881H175.082V167.119H173.781V164.881H171.828V163.389H173.781V161.15H175.082V163.389H177.035Z",
    fill: "#B68C5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.035 181.294V182.786H175.082V185.025H173.781V182.786H171.828V181.294H173.781V179.056H175.082V181.294H177.035Z",
    fill: "#B68C5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.035 199.2V200.692H175.082V202.93H173.781V200.692H171.828V199.2H173.781V196.961H175.082V199.2H177.035Z",
    fill: "#B68C5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.035 217.105V218.598H175.082V220.836H173.781V218.598H171.828V217.105H173.781V214.867H175.082V217.105H177.035Z",
    fill: "#B68C5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.035 235.011V236.503H175.082V238.741H173.781V236.503H171.828V235.011H173.781V232.773H175.082V235.011H177.035Z",
    fill: "#B68C5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.035 252.916V254.409H175.082V256.647H173.781V254.409H171.828V252.916H173.781V250.678H175.082V252.916H177.035Z",
    fill: "#B68C5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.035 270.822V272.314H175.082V274.553H173.781V272.314H171.828V270.822H173.781V268.584H175.082V270.822H177.035Z",
    fill: "#B68C5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.035 288.728V290.22H175.082V292.458H173.781V290.22H171.828V288.728H173.781V286.49H175.082V288.728H177.035Z",
    fill: "#B68C5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.035 306.633V308.125H175.082V310.364H173.781V308.125H171.828V306.633H173.781V304.395H175.082V306.633H177.035Z",
    fill: "#B68C5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.035 324.539V326.031H175.082V328.269H173.781V326.031H171.828V324.539H173.781V322.301H175.082V324.539H177.035Z",
    fill: "#B68C5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.035 342.444V343.937H175.082V346.175H173.781V343.937H171.828V342.444H173.781V340.206H175.082V342.444H177.035Z",
    fill: "#B68C5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.414 2.2382V3.73034H159.461V5.96854H158.16V3.73034H156.207V2.2382H158.16V0H159.461V2.2382H161.414Z",
    fill: "#B68C5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.414 20.1437V21.6359H159.461V23.8741H158.16V21.6359H156.207V20.1437H158.16V17.9055H159.461V20.1437H161.414Z",
    fill: "#B68C5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.414 38.0495V39.5416H159.461V41.7798H158.16V39.5416H156.207V38.0495H158.16V35.8113H159.461V38.0495H161.414Z",
    fill: "#B68C5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.414 55.955V57.4471H159.461V59.6853H158.16V57.4471H156.207V55.955H158.16V53.7168H159.461V55.955H161.414Z",
    fill: "#B68C5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.414 73.8605V75.3527H159.461V77.5909H158.16V75.3527H156.207V73.8605H158.16V71.6223H159.461V73.8605H161.414Z",
    fill: "#B68C5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.414 91.766V93.2582H159.461V95.4964H158.16V93.2582H156.207V91.766H158.16V89.5278H159.461V91.766H161.414Z",
    fill: "#B68C5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.414 109.672V111.164H159.461V113.402H158.16V111.164H156.207V109.672H158.16V107.434H159.461V109.672H161.414Z",
    fill: "#B68C5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.414 127.577V129.069H159.461V131.308H158.16V129.069H156.207V127.577H158.16V125.339H159.461V127.577H161.414Z",
    fill: "#B68C5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.414 145.483V146.975H159.461V149.213H158.16V146.975H156.207V145.483H158.16V143.245H159.461V145.483H161.414Z",
    fill: "#B68C5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.414 163.389V164.881H159.461V167.119H158.16V164.881H156.207V163.389H158.16V161.15H159.461V163.389H161.414Z",
    fill: "#B68C5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.414 181.294V182.786H159.461V185.025H158.16V182.786H156.207V181.294H158.16V179.056H159.461V181.294H161.414Z",
    fill: "#B68C5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.414 199.2V200.692H159.461V202.93H158.16V200.692H156.207V199.2H158.16V196.961H159.461V199.2H161.414Z",
    fill: "#B68C5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.414 217.105V218.598H159.461V220.836H158.16V218.598H156.207V217.105H158.16V214.867H159.461V217.105H161.414Z",
    fill: "#B68C5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.414 235.011V236.503H159.461V238.741H158.16V236.503H156.207V235.011H158.16V232.773H159.461V235.011H161.414Z",
    fill: "#B68C5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.414 252.916V254.409H159.461V256.647H158.16V254.409H156.207V252.916H158.16V250.678H159.461V252.916H161.414Z",
    fill: "#B68C5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.414 270.822V272.314H159.461V274.553H158.16V272.314H156.207V270.822H158.16V268.584H159.461V270.822H161.414Z",
    fill: "#B68C5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.414 288.728V290.22H159.461V292.458H158.16V290.22H156.207V288.728H158.16V286.49H159.461V288.728H161.414Z",
    fill: "#B68C5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.414 306.633V308.125H159.461V310.364H158.16V308.125H156.207V306.633H158.16V304.395H159.461V306.633H161.414Z",
    fill: "#B68C5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.414 324.539V326.031H159.461V328.269H158.16V326.031H156.207V324.539H158.16V322.301H159.461V324.539H161.414Z",
    fill: "#B68C5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.414 342.444V343.937H159.461V346.175H158.16V343.937H156.207V342.444H158.16V340.206H159.461V342.444H161.414Z",
    fill: "#B68C5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.793 2.2382V3.73034H143.84V5.96854H142.539V3.73034H140.586V2.2382H142.539V0H143.84V2.2382H145.793Z",
    fill: "#B68C5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.793 20.1437V21.6359H143.84V23.8741H142.539V21.6359H140.586V20.1437H142.539V17.9055H143.84V20.1437H145.793Z",
    fill: "#B68C5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.793 38.0495V39.5416H143.84V41.7798H142.539V39.5416H140.586V38.0495H142.539V35.8113H143.84V38.0495H145.793Z",
    fill: "#B68C5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.793 55.955V57.4471H143.84V59.6853H142.539V57.4471H140.586V55.955H142.539V53.7168H143.84V55.955H145.793Z",
    fill: "#B68C5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.793 73.8605V75.3527H143.84V77.5909H142.539V75.3527H140.586V73.8605H142.539V71.6223H143.84V73.8605H145.793Z",
    fill: "#B68C5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.793 91.766V93.2582H143.84V95.4964H142.539V93.2582H140.586V91.766H142.539V89.5278H143.84V91.766H145.793Z",
    fill: "#B68C5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.793 109.672V111.164H143.84V113.402H142.539V111.164H140.586V109.672H142.539V107.434H143.84V109.672H145.793Z",
    fill: "#B68C5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.793 127.577V129.069H143.84V131.308H142.539V129.069H140.586V127.577H142.539V125.339H143.84V127.577H145.793Z",
    fill: "#B68C5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.793 145.483V146.975H143.84V149.213H142.539V146.975H140.586V145.483H142.539V143.245H143.84V145.483H145.793Z",
    fill: "#B68C5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.793 163.389V164.881H143.84V167.119H142.539V164.881H140.586V163.389H142.539V161.15H143.84V163.389H145.793Z",
    fill: "#B68C5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.793 181.294V182.786H143.84V185.025H142.539V182.786H140.586V181.294H142.539V179.056H143.84V181.294H145.793Z",
    fill: "#B68C5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.793 199.2V200.692H143.84V202.93H142.539V200.692H140.586V199.2H142.539V196.961H143.84V199.2H145.793Z",
    fill: "#B68C5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.793 217.105V218.598H143.84V220.836H142.539V218.598H140.586V217.105H142.539V214.867H143.84V217.105H145.793Z",
    fill: "#B68C5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.793 235.011V236.503H143.84V238.741H142.539V236.503H140.586V235.011H142.539V232.773H143.84V235.011H145.793Z",
    fill: "#B68C5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.793 252.916V254.409H143.84V256.647H142.539V254.409H140.586V252.916H142.539V250.678H143.84V252.916H145.793Z",
    fill: "#B68C5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.793 270.822V272.314H143.84V274.553H142.539V272.314H140.586V270.822H142.539V268.584H143.84V270.822H145.793Z",
    fill: "#B68C5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.793 288.728V290.22H143.84V292.458H142.539V290.22H140.586V288.728H142.539V286.49H143.84V288.728H145.793Z",
    fill: "#B68C5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.793 306.633V308.125H143.84V310.364H142.539V308.125H140.586V306.633H142.539V304.395H143.84V306.633H145.793Z",
    fill: "#B68C5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.793 324.539V326.031H143.84V328.269H142.539V326.031H140.586V324.539H142.539V322.301H143.84V324.539H145.793Z",
    fill: "#B68C5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.793 342.444V343.937H143.84V346.175H142.539V343.937H140.586V342.444H142.539V340.206H143.84V342.444H145.793Z",
    fill: "#B68C5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.173 2.2382V3.73034H128.22V5.96854H126.918V3.73034H124.966V2.2382H126.918V0H128.22V2.2382H130.173Z",
    fill: "#B68C5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.173 20.1437V21.6359H128.22V23.8741H126.918V21.6359H124.966V20.1437H126.918V17.9055H128.22V20.1437H130.173Z",
    fill: "#B68C5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.173 38.0495V39.5416H128.22V41.7798H126.918V39.5416H124.966V38.0495H126.918V35.8113H128.22V38.0495H130.173Z",
    fill: "#B68C5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.173 55.955V57.4471H128.22V59.6853H126.918V57.4471H124.966V55.955H126.918V53.7168H128.22V55.955H130.173Z",
    fill: "#B68C5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.173 73.8605V75.3527H128.22V77.5909H126.918V75.3527H124.966V73.8605H126.918V71.6223H128.22V73.8605H130.173Z",
    fill: "#B68C5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.173 91.766V93.2582H128.22V95.4964H126.918V93.2582H124.966V91.766H126.918V89.5278H128.22V91.766H130.173Z",
    fill: "#B68C5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.173 109.672V111.164H128.22V113.402H126.918V111.164H124.966V109.672H126.918V107.434H128.22V109.672H130.173Z",
    fill: "#B68C5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.173 127.577V129.069H128.22V131.308H126.918V129.069H124.966V127.577H126.918V125.339H128.22V127.577H130.173Z",
    fill: "#B68C5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.173 145.483V146.975H128.22V149.213H126.918V146.975H124.966V145.483H126.918V143.245H128.22V145.483H130.173Z",
    fill: "#B68C5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.173 163.389V164.881H128.22V167.119H126.918V164.881H124.966V163.389H126.918V161.15H128.22V163.389H130.173Z",
    fill: "#B68C5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.173 181.294V182.786H128.22V185.025H126.918V182.786H124.966V181.294H126.918V179.056H128.22V181.294H130.173Z",
    fill: "#B68C5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.173 199.2V200.692H128.22V202.93H126.918V200.692H124.966V199.2H126.918V196.961H128.22V199.2H130.173Z",
    fill: "#B68C5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.173 217.105V218.598H128.22V220.836H126.918V218.598H124.966V217.105H126.918V214.867H128.22V217.105H130.173Z",
    fill: "#B68C5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.173 235.011V236.503H128.22V238.741H126.918V236.503H124.966V235.011H126.918V232.773H128.22V235.011H130.173Z",
    fill: "#B68C5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.173 252.916V254.409H128.22V256.647H126.918V254.409H124.966V252.916H126.918V250.678H128.22V252.916H130.173Z",
    fill: "#B68C5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.173 270.822V272.314H128.22V274.553H126.918V272.314H124.966V270.822H126.918V268.584H128.22V270.822H130.173Z",
    fill: "#B68C5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.173 288.728V290.22H128.22V292.458H126.918V290.22H124.966V288.728H126.918V286.49H128.22V288.728H130.173Z",
    fill: "#B68C5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.173 306.633V308.125H128.22V310.364H126.918V308.125H124.966V306.633H126.918V304.395H128.22V306.633H130.173Z",
    fill: "#B68C5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.173 324.539V326.031H128.22V328.269H126.918V326.031H124.966V324.539H126.918V322.301H128.22V324.539H130.173Z",
    fill: "#B68C5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.173 342.444V343.937H128.22V346.175H126.918V343.937H124.966V342.444H126.918V340.206H128.22V342.444H130.173Z",
    fill: "#B68C5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.552 2.2382V3.73034H112.599V5.96854H111.297V3.73034H109.345V2.2382H111.297V0H112.599V2.2382H114.552Z",
    fill: "#B68C5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.552 20.1437V21.6359H112.599V23.8741H111.297V21.6359H109.345V20.1437H111.297V17.9055H112.599V20.1437H114.552Z",
    fill: "#B68C5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.552 38.0495V39.5416H112.599V41.7798H111.297V39.5416H109.345V38.0495H111.297V35.8113H112.599V38.0495H114.552Z",
    fill: "#B68C5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.552 55.955V57.4471H112.599V59.6853H111.297V57.4471H109.345V55.955H111.297V53.7168H112.599V55.955H114.552Z",
    fill: "#B68C5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.552 73.8605V75.3527H112.599V77.5909H111.297V75.3527H109.345V73.8605H111.297V71.6223H112.599V73.8605H114.552Z",
    fill: "#B68C5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.552 91.766V93.2582H112.599V95.4964H111.297V93.2582H109.345V91.766H111.297V89.5278H112.599V91.766H114.552Z",
    fill: "#B68C5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.552 109.672V111.164H112.599V113.402H111.297V111.164H109.345V109.672H111.297V107.434H112.599V109.672H114.552Z",
    fill: "#B68C5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.552 127.577V129.069H112.599V131.308H111.297V129.069H109.345V127.577H111.297V125.339H112.599V127.577H114.552Z",
    fill: "#B68C5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.552 145.483V146.975H112.599V149.213H111.297V146.975H109.345V145.483H111.297V143.245H112.599V145.483H114.552Z",
    fill: "#B68C5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.552 163.389V164.881H112.599V167.119H111.297V164.881H109.345V163.389H111.297V161.15H112.599V163.389H114.552Z",
    fill: "#B68C5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.552 181.294V182.786H112.599V185.025H111.297V182.786H109.345V181.294H111.297V179.056H112.599V181.294H114.552Z",
    fill: "#B68C5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.552 199.2V200.692H112.599V202.93H111.297V200.692H109.345V199.2H111.297V196.961H112.599V199.2H114.552Z",
    fill: "#B68C5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.552 217.105V218.598H112.599V220.836H111.297V218.598H109.345V217.105H111.297V214.867H112.599V217.105H114.552Z",
    fill: "#B68C5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.552 235.011V236.503H112.599V238.741H111.297V236.503H109.345V235.011H111.297V232.773H112.599V235.011H114.552Z",
    fill: "#B68C5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.552 252.916V254.409H112.599V256.647H111.297V254.409H109.345V252.916H111.297V250.678H112.599V252.916H114.552Z",
    fill: "#B68C5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.552 270.822V272.314H112.599V274.553H111.297V272.314H109.345V270.822H111.297V268.584H112.599V270.822H114.552Z",
    fill: "#B68C5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.552 288.728V290.22H112.599V292.458H111.297V290.22H109.345V288.728H111.297V286.49H112.599V288.728H114.552Z",
    fill: "#B68C5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.552 306.633V308.125H112.599V310.364H111.297V308.125H109.345V306.633H111.297V304.395H112.599V306.633H114.552Z",
    fill: "#B68C5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.552 324.539V326.031H112.599V328.269H111.297V326.031H109.345V324.539H111.297V322.301H112.599V324.539H114.552Z",
    fill: "#B68C5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.552 342.444V343.937H112.599V346.175H111.297V343.937H109.345V342.444H111.297V340.206H112.599V342.444H114.552Z",
    fill: "#B68C5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.9305 2.2382V3.73034H96.978V5.96854H95.6762V3.73034H93.7236V2.2382H95.6762V0H96.978V2.2382H98.9305Z",
    fill: "#B68C5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.9305 20.1437V21.6359H96.978V23.8741H95.6762V21.6359H93.7236V20.1437H95.6762V17.9055H96.978V20.1437H98.9305Z",
    fill: "#B68C5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.9305 38.0495V39.5416H96.978V41.7798H95.6762V39.5416H93.7236V38.0495H95.6762V35.8113H96.978V38.0495H98.9305Z",
    fill: "#B68C5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.9305 55.955V57.4471H96.978V59.6853H95.6762V57.4471H93.7236V55.955H95.6762V53.7168H96.978V55.955H98.9305Z",
    fill: "#B68C5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.9305 73.8605V75.3527H96.978V77.5909H95.6762V75.3527H93.7236V73.8605H95.6762V71.6223H96.978V73.8605H98.9305Z",
    fill: "#B68C5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.9305 91.766V93.2582H96.978V95.4964H95.6762V93.2582H93.7236V91.766H95.6762V89.5278H96.978V91.766H98.9305Z",
    fill: "#B68C5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.9305 109.672V111.164H96.978V113.402H95.6762V111.164H93.7236V109.672H95.6762V107.434H96.978V109.672H98.9305Z",
    fill: "#B68C5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.9305 127.577V129.069H96.978V131.308H95.6762V129.069H93.7236V127.577H95.6762V125.339H96.978V127.577H98.9305Z",
    fill: "#B68C5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.9305 145.483V146.975H96.978V149.213H95.6762V146.975H93.7236V145.483H95.6762V143.245H96.978V145.483H98.9305Z",
    fill: "#B68C5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.9305 163.389V164.881H96.978V167.119H95.6762V164.881H93.7236V163.389H95.6762V161.15H96.978V163.389H98.9305Z",
    fill: "#B68C5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.9305 181.294V182.786H96.978V185.025H95.6762V182.786H93.7236V181.294H95.6762V179.056H96.978V181.294H98.9305Z",
    fill: "#B68C5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.9305 199.2V200.692H96.978V202.93H95.6762V200.692H93.7236V199.2H95.6762V196.961H96.978V199.2H98.9305Z",
    fill: "#B68C5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.9305 217.105V218.598H96.978V220.836H95.6762V218.598H93.7236V217.105H95.6762V214.867H96.978V217.105H98.9305Z",
    fill: "#B68C5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.9305 235.011V236.503H96.978V238.741H95.6762V236.503H93.7236V235.011H95.6762V232.773H96.978V235.011H98.9305Z",
    fill: "#B68C5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.9305 252.916V254.409H96.978V256.647H95.6762V254.409H93.7236V252.916H95.6762V250.678H96.978V252.916H98.9305Z",
    fill: "#B68C5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.9305 270.822V272.314H96.978V274.553H95.6762V272.314H93.7236V270.822H95.6762V268.584H96.978V270.822H98.9305Z",
    fill: "#B68C5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.9305 288.728V290.22H96.978V292.458H95.6762V290.22H93.7236V288.728H95.6762V286.49H96.978V288.728H98.9305Z",
    fill: "#B68C5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.9305 306.633V308.125H96.978V310.364H95.6762V308.125H93.7236V306.633H95.6762V304.395H96.978V306.633H98.9305Z",
    fill: "#B68C5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.9305 324.539V326.031H96.978V328.269H95.6762V326.031H93.7236V324.539H95.6762V322.301H96.978V324.539H98.9305Z",
    fill: "#B68C5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.9305 342.444V343.937H96.978V346.175H95.6762V343.937H93.7236V342.444H95.6762V340.206H96.978V342.444H98.9305Z",
    fill: "#B68C5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.3104 2.2382V3.73034H81.3578V5.96854H80.0561V3.73034H78.1035V2.2382H80.0561V0H81.3578V2.2382H83.3104Z",
    fill: "#B68C5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.3104 20.1437V21.6359H81.3578V23.8741H80.0561V21.6359H78.1035V20.1437H80.0561V17.9055H81.3578V20.1437H83.3104Z",
    fill: "#B68C5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.3104 38.0495V39.5416H81.3578V41.7798H80.0561V39.5416H78.1035V38.0495H80.0561V35.8113H81.3578V38.0495H83.3104Z",
    fill: "#B68C5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.3104 55.955V57.4471H81.3578V59.6853H80.0561V57.4471H78.1035V55.955H80.0561V53.7168H81.3578V55.955H83.3104Z",
    fill: "#B68C5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.3104 73.8605V75.3527H81.3578V77.5909H80.0561V75.3527H78.1035V73.8605H80.0561V71.6223H81.3578V73.8605H83.3104Z",
    fill: "#B68C5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.3104 91.766V93.2582H81.3578V95.4964H80.0561V93.2582H78.1035V91.766H80.0561V89.5278H81.3578V91.766H83.3104Z",
    fill: "#B68C5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.3104 109.672V111.164H81.3578V113.402H80.0561V111.164H78.1035V109.672H80.0561V107.434H81.3578V109.672H83.3104Z",
    fill: "#B68C5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.3104 127.577V129.069H81.3578V131.308H80.0561V129.069H78.1035V127.577H80.0561V125.339H81.3578V127.577H83.3104Z",
    fill: "#B68C5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.3104 145.483V146.975H81.3578V149.213H80.0561V146.975H78.1035V145.483H80.0561V143.245H81.3578V145.483H83.3104Z",
    fill: "#B68C5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.3104 163.389V164.881H81.3578V167.119H80.0561V164.881H78.1035V163.389H80.0561V161.15H81.3578V163.389H83.3104Z",
    fill: "#B68C5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.3104 181.294V182.786H81.3578V185.025H80.0561V182.786H78.1035V181.294H80.0561V179.056H81.3578V181.294H83.3104Z",
    fill: "#B68C5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.3104 199.2V200.692H81.3578V202.93H80.0561V200.692H78.1035V199.2H80.0561V196.961H81.3578V199.2H83.3104Z",
    fill: "#B68C5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.3104 217.105V218.598H81.3578V220.836H80.0561V218.598H78.1035V217.105H80.0561V214.867H81.3578V217.105H83.3104Z",
    fill: "#B68C5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.3104 235.011V236.503H81.3578V238.741H80.0561V236.503H78.1035V235.011H80.0561V232.773H81.3578V235.011H83.3104Z",
    fill: "#B68C5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.3104 252.916V254.409H81.3578V256.647H80.0561V254.409H78.1035V252.916H80.0561V250.678H81.3578V252.916H83.3104Z",
    fill: "#B68C5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.3104 270.822V272.314H81.3578V274.553H80.0561V272.314H78.1035V270.822H80.0561V268.584H81.3578V270.822H83.3104Z",
    fill: "#B68C5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.3104 288.728V290.22H81.3578V292.458H80.0561V290.22H78.1035V288.728H80.0561V286.49H81.3578V288.728H83.3104Z",
    fill: "#B68C5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.3104 306.633V308.125H81.3578V310.364H80.0561V308.125H78.1035V306.633H80.0561V304.395H81.3578V306.633H83.3104Z",
    fill: "#B68C5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.3104 324.539V326.031H81.3578V328.269H80.0561V326.031H78.1035V324.539H80.0561V322.301H81.3578V324.539H83.3104Z",
    fill: "#B68C5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.3104 342.444V343.937H81.3578V346.175H80.0561V343.937H78.1035V342.444H80.0561V340.206H81.3578V342.444H83.3104Z",
    fill: "#B68C5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.6893 2.2382V3.73034H65.7367V5.96854H64.435V3.73034H62.4824V2.2382H64.435V0H65.7367V2.2382H67.6893Z",
    fill: "#B68C5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.6893 20.1437V21.6359H65.7367V23.8741H64.435V21.6359H62.4824V20.1437H64.435V17.9055H65.7367V20.1437H67.6893Z",
    fill: "#B68C5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.6893 38.0495V39.5416H65.7367V41.7798H64.435V39.5416H62.4824V38.0495H64.435V35.8113H65.7367V38.0495H67.6893Z",
    fill: "#B68C5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.6893 55.955V57.4471H65.7367V59.6853H64.435V57.4471H62.4824V55.955H64.435V53.7168H65.7367V55.955H67.6893Z",
    fill: "#B68C5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.6893 73.8605V75.3527H65.7367V77.5909H64.435V75.3527H62.4824V73.8605H64.435V71.6223H65.7367V73.8605H67.6893Z",
    fill: "#B68C5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.6893 91.766V93.2582H65.7367V95.4964H64.435V93.2582H62.4824V91.766H64.435V89.5278H65.7367V91.766H67.6893Z",
    fill: "#B68C5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.6893 109.672V111.164H65.7367V113.402H64.435V111.164H62.4824V109.672H64.435V107.434H65.7367V109.672H67.6893Z",
    fill: "#B68C5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.6893 127.577V129.069H65.7367V131.308H64.435V129.069H62.4824V127.577H64.435V125.339H65.7367V127.577H67.6893Z",
    fill: "#B68C5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.6893 145.483V146.975H65.7367V149.213H64.435V146.975H62.4824V145.483H64.435V143.245H65.7367V145.483H67.6893Z",
    fill: "#B68C5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.6893 163.389V164.881H65.7367V167.119H64.435V164.881H62.4824V163.389H64.435V161.15H65.7367V163.389H67.6893Z",
    fill: "#B68C5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.6893 181.294V182.786H65.7367V185.025H64.435V182.786H62.4824V181.294H64.435V179.056H65.7367V181.294H67.6893Z",
    fill: "#B68C5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.6893 199.2V200.692H65.7367V202.93H64.435V200.692H62.4824V199.2H64.435V196.961H65.7367V199.2H67.6893Z",
    fill: "#B68C5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.6893 217.105V218.598H65.7367V220.836H64.435V218.598H62.4824V217.105H64.435V214.867H65.7367V217.105H67.6893Z",
    fill: "#B68C5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.6893 235.011V236.503H65.7367V238.741H64.435V236.503H62.4824V235.011H64.435V232.773H65.7367V235.011H67.6893Z",
    fill: "#B68C5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.6893 252.916V254.409H65.7367V256.647H64.435V254.409H62.4824V252.916H64.435V250.678H65.7367V252.916H67.6893Z",
    fill: "#B68C5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.6893 270.822V272.314H65.7367V274.553H64.435V272.314H62.4824V270.822H64.435V268.584H65.7367V270.822H67.6893Z",
    fill: "#B68C5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.6893 288.728V290.22H65.7367V292.458H64.435V290.22H62.4824V288.728H64.435V286.49H65.7367V288.728H67.6893Z",
    fill: "#B68C5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.6893 306.633V308.125H65.7367V310.364H64.435V308.125H62.4824V306.633H64.435V304.395H65.7367V306.633H67.6893Z",
    fill: "#B68C5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.6893 324.539V326.031H65.7367V328.269H64.435V326.031H62.4824V324.539H64.435V322.301H65.7367V324.539H67.6893Z",
    fill: "#B68C5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.6893 342.444V343.937H65.7367V346.175H64.435V343.937H62.4824V342.444H64.435V340.206H65.7367V342.444H67.6893Z",
    fill: "#B68C5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.0692 2.2382V3.73034H50.1166V5.96854H48.8149V3.73034H46.8623V2.2382H48.8149V0H50.1166V2.2382H52.0692Z",
    fill: "#B68C5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.0692 20.1437V21.6359H50.1166V23.8741H48.8149V21.6359H46.8623V20.1437H48.8149V17.9055H50.1166V20.1437H52.0692Z",
    fill: "#B68C5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.0692 38.0495V39.5416H50.1166V41.7798H48.8149V39.5416H46.8623V38.0495H48.8149V35.8113H50.1166V38.0495H52.0692Z",
    fill: "#B68C5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.0692 55.955V57.4471H50.1166V59.6853H48.8149V57.4471H46.8623V55.955H48.8149V53.7168H50.1166V55.955H52.0692Z",
    fill: "#B68C5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.0692 73.8605V75.3527H50.1166V77.5909H48.8149V75.3527H46.8623V73.8605H48.8149V71.6223H50.1166V73.8605H52.0692Z",
    fill: "#B68C5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.0692 91.766V93.2582H50.1166V95.4964H48.8149V93.2582H46.8623V91.766H48.8149V89.5278H50.1166V91.766H52.0692Z",
    fill: "#B68C5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.0692 109.672V111.164H50.1166V113.402H48.8149V111.164H46.8623V109.672H48.8149V107.434H50.1166V109.672H52.0692Z",
    fill: "#B68C5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.0692 127.577V129.069H50.1166V131.308H48.8149V129.069H46.8623V127.577H48.8149V125.339H50.1166V127.577H52.0692Z",
    fill: "#B68C5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.0692 145.483V146.975H50.1166V149.213H48.8149V146.975H46.8623V145.483H48.8149V143.245H50.1166V145.483H52.0692Z",
    fill: "#B68C5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.0692 163.389V164.881H50.1166V167.119H48.8149V164.881H46.8623V163.389H48.8149V161.15H50.1166V163.389H52.0692Z",
    fill: "#B68C5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.0692 181.294V182.786H50.1166V185.025H48.8149V182.786H46.8623V181.294H48.8149V179.056H50.1166V181.294H52.0692Z",
    fill: "#B68C5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.0692 199.2V200.692H50.1166V202.93H48.8149V200.692H46.8623V199.2H48.8149V196.961H50.1166V199.2H52.0692Z",
    fill: "#B68C5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.0692 217.105V218.598H50.1166V220.836H48.8149V218.598H46.8623V217.105H48.8149V214.867H50.1166V217.105H52.0692Z",
    fill: "#B68C5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.0692 235.011V236.503H50.1166V238.741H48.8149V236.503H46.8623V235.011H48.8149V232.773H50.1166V235.011H52.0692Z",
    fill: "#B68C5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.0692 252.916V254.409H50.1166V256.647H48.8149V254.409H46.8623V252.916H48.8149V250.678H50.1166V252.916H52.0692Z",
    fill: "#B68C5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.0692 270.822V272.314H50.1166V274.553H48.8149V272.314H46.8623V270.822H48.8149V268.584H50.1166V270.822H52.0692Z",
    fill: "#B68C5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.0692 288.728V290.22H50.1166V292.458H48.8149V290.22H46.8623V288.728H48.8149V286.49H50.1166V288.728H52.0692Z",
    fill: "#B68C5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.0692 306.633V308.125H50.1166V310.364H48.8149V308.125H46.8623V306.633H48.8149V304.395H50.1166V306.633H52.0692Z",
    fill: "#B68C5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.0692 324.539V326.031H50.1166V328.269H48.8149V326.031H46.8623V324.539H48.8149V322.301H50.1166V324.539H52.0692Z",
    fill: "#B68C5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.0692 342.444V343.937H50.1166V346.175H48.8149V343.937H46.8623V342.444H48.8149V340.206H50.1166V342.444H52.0692Z",
    fill: "#B68C5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.4481 2.2382V3.73034H34.4955V5.96854H33.1938V3.73034H31.2412V2.2382H33.1938V0H34.4955V2.2382H36.4481Z",
    fill: "#B68C5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.4481 20.1437V21.6359H34.4955V23.8741H33.1938V21.6359H31.2412V20.1437H33.1938V17.9055H34.4955V20.1437H36.4481Z",
    fill: "#B68C5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.4481 38.0495V39.5416H34.4955V41.7798H33.1938V39.5416H31.2412V38.0495H33.1938V35.8113H34.4955V38.0495H36.4481Z",
    fill: "#B68C5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.4481 55.955V57.4471H34.4955V59.6853H33.1938V57.4471H31.2412V55.955H33.1938V53.7168H34.4955V55.955H36.4481Z",
    fill: "#B68C5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.4481 73.8605V75.3527H34.4955V77.5909H33.1938V75.3527H31.2412V73.8605H33.1938V71.6223H34.4955V73.8605H36.4481Z",
    fill: "#B68C5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.4481 91.766V93.2582H34.4955V95.4964H33.1938V93.2582H31.2412V91.766H33.1938V89.5278H34.4955V91.766H36.4481Z",
    fill: "#B68C5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.4481 109.672V111.164H34.4955V113.402H33.1938V111.164H31.2412V109.672H33.1938V107.434H34.4955V109.672H36.4481Z",
    fill: "#B68C5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.4481 127.577V129.069H34.4955V131.308H33.1938V129.069H31.2412V127.577H33.1938V125.339H34.4955V127.577H36.4481Z",
    fill: "#B68C5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.4481 145.483V146.975H34.4955V149.213H33.1938V146.975H31.2412V145.483H33.1938V143.245H34.4955V145.483H36.4481Z",
    fill: "#B68C5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.4481 163.389V164.881H34.4955V167.119H33.1938V164.881H31.2412V163.389H33.1938V161.15H34.4955V163.389H36.4481Z",
    fill: "#B68C5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.4481 181.294V182.786H34.4955V185.025H33.1938V182.786H31.2412V181.294H33.1938V179.056H34.4955V181.294H36.4481Z",
    fill: "#B68C5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.4481 199.2V200.692H34.4955V202.93H33.1938V200.692H31.2412V199.2H33.1938V196.961H34.4955V199.2H36.4481Z",
    fill: "#B68C5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.4481 217.105V218.598H34.4955V220.836H33.1938V218.598H31.2412V217.105H33.1938V214.867H34.4955V217.105H36.4481Z",
    fill: "#B68C5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.4481 235.011V236.503H34.4955V238.741H33.1938V236.503H31.2412V235.011H33.1938V232.773H34.4955V235.011H36.4481Z",
    fill: "#B68C5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.4481 252.916V254.409H34.4955V256.647H33.1938V254.409H31.2412V252.916H33.1938V250.678H34.4955V252.916H36.4481Z",
    fill: "#B68C5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.4481 270.822V272.314H34.4955V274.553H33.1938V272.314H31.2412V270.822H33.1938V268.584H34.4955V270.822H36.4481Z",
    fill: "#B68C5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.4481 288.728V290.22H34.4955V292.458H33.1938V290.22H31.2412V288.728H33.1938V286.49H34.4955V288.728H36.4481Z",
    fill: "#B68C5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.4481 306.633V308.125H34.4955V310.364H33.1938V308.125H31.2412V306.633H33.1938V304.395H34.4955V306.633H36.4481Z",
    fill: "#B68C5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.4481 324.539V326.031H34.4955V328.269H33.1938V326.031H31.2412V324.539H33.1938V322.301H34.4955V324.539H36.4481Z",
    fill: "#B68C5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.4481 342.444V343.937H34.4955V346.175H33.1938V343.937H31.2412V342.444H33.1938V340.206H34.4955V342.444H36.4481Z",
    fill: "#B68C5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.828 2.2382V3.73034H18.8754V5.96854H17.5737V3.73034H15.6211V2.2382H17.5737V0H18.8754V2.2382H20.828Z",
    fill: "#B68C5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.828 20.1437V21.6359H18.8754V23.8741H17.5737V21.6359H15.6211V20.1437H17.5737V17.9055H18.8754V20.1437H20.828Z",
    fill: "#B68C5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.828 38.0495V39.5416H18.8754V41.7798H17.5737V39.5416H15.6211V38.0495H17.5737V35.8113H18.8754V38.0495H20.828Z",
    fill: "#B68C5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.828 55.955V57.4471H18.8754V59.6853H17.5737V57.4471H15.6211V55.955H17.5737V53.7168H18.8754V55.955H20.828Z",
    fill: "#B68C5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.828 73.8605V75.3527H18.8754V77.5909H17.5737V75.3527H15.6211V73.8605H17.5737V71.6223H18.8754V73.8605H20.828Z",
    fill: "#B68C5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.828 91.766V93.2582H18.8754V95.4964H17.5737V93.2582H15.6211V91.766H17.5737V89.5278H18.8754V91.766H20.828Z",
    fill: "#B68C5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.828 109.672V111.164H18.8754V113.402H17.5737V111.164H15.6211V109.672H17.5737V107.434H18.8754V109.672H20.828Z",
    fill: "#B68C5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.828 127.577V129.069H18.8754V131.308H17.5737V129.069H15.6211V127.577H17.5737V125.339H18.8754V127.577H20.828Z",
    fill: "#B68C5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.828 145.483V146.975H18.8754V149.213H17.5737V146.975H15.6211V145.483H17.5737V143.245H18.8754V145.483H20.828Z",
    fill: "#B68C5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.828 163.389V164.881H18.8754V167.119H17.5737V164.881H15.6211V163.389H17.5737V161.15H18.8754V163.389H20.828Z",
    fill: "#B68C5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.828 181.294V182.786H18.8754V185.025H17.5737V182.786H15.6211V181.294H17.5737V179.056H18.8754V181.294H20.828Z",
    fill: "#B68C5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.828 199.2V200.692H18.8754V202.93H17.5737V200.692H15.6211V199.2H17.5737V196.961H18.8754V199.2H20.828Z",
    fill: "#B68C5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.828 217.105V218.598H18.8754V220.836H17.5737V218.598H15.6211V217.105H17.5737V214.867H18.8754V217.105H20.828Z",
    fill: "#B68C5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.828 235.011V236.503H18.8754V238.741H17.5737V236.503H15.6211V235.011H17.5737V232.773H18.8754V235.011H20.828Z",
    fill: "#B68C5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.828 252.916V254.409H18.8754V256.647H17.5737V254.409H15.6211V252.916H17.5737V250.678H18.8754V252.916H20.828Z",
    fill: "#B68C5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.828 270.822V272.314H18.8754V274.553H17.5737V272.314H15.6211V270.822H17.5737V268.584H18.8754V270.822H20.828Z",
    fill: "#B68C5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.828 288.728V290.22H18.8754V292.458H17.5737V290.22H15.6211V288.728H17.5737V286.49H18.8754V288.728H20.828Z",
    fill: "#B68C5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.828 306.633V308.125H18.8754V310.364H17.5737V308.125H15.6211V306.633H17.5737V304.395H18.8754V306.633H20.828Z",
    fill: "#B68C5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.828 324.539V326.031H18.8754V328.269H17.5737V326.031H15.6211V324.539H17.5737V322.301H18.8754V324.539H20.828Z",
    fill: "#B68C5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.828 342.444V343.937H18.8754V346.175H17.5737V343.937H15.6211V342.444H17.5737V340.206H18.8754V342.444H20.828Z",
    fill: "#B68C5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.20691 2.2382V3.73034H3.25432V5.96854H1.95259V3.73034H0V2.2382H1.95259V0H3.25432V2.2382H5.20691Z",
    fill: "#B68C5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.20691 20.1437V21.6359H3.25432V23.8741H1.95259V21.6359H0V20.1437H1.95259V17.9055H3.25432V20.1437H5.20691Z",
    fill: "#B68C5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.20691 38.0495V39.5416H3.25432V41.7798H1.95259V39.5416H0V38.0495H1.95259V35.8113H3.25432V38.0495H5.20691Z",
    fill: "#B68C5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.20691 55.955V57.4471H3.25432V59.6853H1.95259V57.4471H0V55.955H1.95259V53.7168H3.25432V55.955H5.20691Z",
    fill: "#B68C5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.20691 73.8605V75.3527H3.25432V77.5909H1.95259V75.3527H0V73.8605H1.95259V71.6223H3.25432V73.8605H5.20691Z",
    fill: "#B68C5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.20691 91.766V93.2582H3.25432V95.4964H1.95259V93.2582H0V91.766H1.95259V89.5278H3.25432V91.766H5.20691Z",
    fill: "#B68C5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.20691 109.672V111.164H3.25432V113.402H1.95259V111.164H0V109.672H1.95259V107.434H3.25432V109.672H5.20691Z",
    fill: "#B68C5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.20691 127.577V129.069H3.25432V131.308H1.95259V129.069H0V127.577H1.95259V125.339H3.25432V127.577H5.20691Z",
    fill: "#B68C5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.20691 145.483V146.975H3.25432V149.213H1.95259V146.975H0V145.483H1.95259V143.245H3.25432V145.483H5.20691Z",
    fill: "#B68C5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.20691 163.389V164.881H3.25432V167.119H1.95259V164.881H0V163.389H1.95259V161.15H3.25432V163.389H5.20691Z",
    fill: "#B68C5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.20691 181.294V182.786H3.25432V185.025H1.95259V182.786H0V181.294H1.95259V179.056H3.25432V181.294H5.20691Z",
    fill: "#B68C5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.20691 199.2V200.692H3.25432V202.93H1.95259V200.692H0V199.2H1.95259V196.961H3.25432V199.2H5.20691Z",
    fill: "#B68C5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.20691 217.105V218.598H3.25432V220.836H1.95259V218.598H0V217.105H1.95259V214.867H3.25432V217.105H5.20691Z",
    fill: "#B68C5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.20691 235.011V236.503H3.25432V238.741H1.95259V236.503H0V235.011H1.95259V232.773H3.25432V235.011H5.20691Z",
    fill: "#B68C5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.20691 252.916V254.409H3.25432V256.647H1.95259V254.409H0V252.916H1.95259V250.678H3.25432V252.916H5.20691Z",
    fill: "#B68C5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.20691 270.822V272.314H3.25432V274.553H1.95259V272.314H0V270.822H1.95259V268.584H3.25432V270.822H5.20691Z",
    fill: "#B68C5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.20691 288.728V290.22H3.25432V292.458H1.95259V290.22H0V288.728H1.95259V286.49H3.25432V288.728H5.20691Z",
    fill: "#B68C5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.20691 306.633V308.125H3.25432V310.364H1.95259V308.125H0V306.633H1.95259V304.395H3.25432V306.633H5.20691Z",
    fill: "#B68C5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.20691 324.539V326.031H3.25432V328.269H1.95259V326.031H0V324.539H1.95259V322.301H3.25432V324.539H5.20691Z",
    fill: "#B68C5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.20691 342.444V343.937H3.25432V346.175H1.95259V343.937H0V342.444H1.95259V340.206H3.25432V342.444H5.20691Z",
    fill: "#B68C5A"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPracticeareaDot);
export default __webpack_public_path__ + "static/media/practicearea_dot.023d5de911c5c14f49ae4d67d62403da.svg";
export { ForwardRef as ReactComponent };